const servicesTitle = ["Identifier", "naming"];
const sizeCategoriesOnPage = 5;

export { servicesTitle, sizeCategoriesOnPage };
